<script setup lang="ts"></script>

<template>
  <div class="error-container">
    <h1>FEHLER - Anfrage fehlgeschlagen</h1>
    <h2>500</h2>
  </div>
</template>

<style scoped lang="scss">
.error-container {
  text-align: left;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;

  h1,
  h2 {
    margin: 1.5rem 0 1rem;
    text-transform: uppercase;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }
}
</style>
